//Bug action types
export const BUG_ADDED = "bugAdded";
export const BUG_REMOVED = "bugRemoved";
export const BUG_RESOLVED = "bugResolved";
export const CREATE_BUG_ERROR = "CREATE_BUG_ERROR";
export const RESOLVE_BUG_ERROR = "resolveBugError";
export const DELETE_BUG_ERROR = "deleteBugError";
export const GET_ALL_BUGS = "getAllBugs";
export const BUG_REMOVED_TEMP = "bugRemovedTemporary";
export const BUG_RESTORED = "bugRestoredFromTrash";

//Authentications action types
export const USER_SIGNIN = "signingInUser";
export const SIGNIN_ERROR = "errorSignIn";
export const LOGOUT = "logoutUser";

//Notifications action types
export const GET_NOTIFICATIONS = "getAllNotifications";
export const GET_NOTIFICATIONS_ERROR = "getNotificationsError";
